// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__2DSSK","column":"style_column__WsrPt"};